// reducer.js
import {
  FETCH_TICKETS_COUNTS_REQUEST,
  FETCH_STATISTICS_REPORT_REQUEST,
  FETCH_COMPLETE_REPORT_REQUEST,
  FETCH_REPORT_HFC_REQUEST,
  FETCH_REPORT_GPON_REQUEST,
  FETCH_REPORT_COPPER_REQUEST,


  FETCH_TICKETS_COUNTS_SUCCESS,
  FETCH_STATISTICS_REPORT_SUCCESS,
  FETCH_COMPLETE_REPORT_SUCCESS,
  FETCH_REPORT_HFC_SUCCESS,
  FETCH_REPORT_GPON_SUCCESS,
  FETCH_REPORT_COPPER_SUCCESS,

  FETCH_TICKETS_COUNTS_FAILURE,
  FETCH_STATISTICS_REPORT_FAILURE,
  FETCH_COMPLETE_REPORT_FAILURE,
  FETCH_REPORT_HFC_FAILURE,
  FETCH_REPORT_GPON_FAILURE,
  FETCH_REPORT_COPPER_FAILURE

} from './actions';

const initialState = {
  tickets_counts: null,
  statistics_report: null,
  complete_report: null,
  report_hfc: null,
  report_gpon: null,
  report_copper: null,
  loading: false,
  error: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TICKETS_COUNTS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_STATISTICS_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_COMPLETE_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_REPORT_HFC_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_REPORT_GPON_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_REPORT_COPPER_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_TICKETS_COUNTS_SUCCESS:
      return { ...state, loading: false, tickets_counts: action.payload };
    case FETCH_STATISTICS_REPORT_SUCCESS:
      return { ...state, loading: true, statistics_report: action.payload };
    case FETCH_COMPLETE_REPORT_SUCCESS:
      return { ...state, loading: false, complete_report: action.payload };
    case FETCH_REPORT_HFC_SUCCESS:
      return { ...state, loading: false, report_hfc: action.payload };
    case FETCH_REPORT_GPON_SUCCESS:
      return { ...state, loading: false, report_gpon: action.payload };
    case FETCH_REPORT_COPPER_SUCCESS:
      return { ...state, loading: false, report_copper: action.payload };

    case FETCH_TICKETS_COUNTS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_STATISTICS_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_COMPLETE_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_REPORT_HFC_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_REPORT_GPON_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_REPORT_COPPER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default dashboardReducer;
